import styled from '../../../../styles/theme';
import { ModalCarOptionDetailStyled } from '../ModalCarOptionDetailStyled';
import { rem } from 'polished';

export const ModalCarOptionDetailStyledAP = styled(ModalCarOptionDetailStyled)`
    .option-detail {
        &__category {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            color: ${({ theme }) => theme.colors.primaryBlack};
        }

        &__title {
            font-size: ${rem(18)};
            color: ${({ theme }) => theme.colors.primaryBlack};
            line-height: ${rem(20)};
        }

        &__description {
            color: ${({ theme }) => theme.colors.primaryBlack};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            line-height: ${rem(18)};
        }
    }
`;
